import { Component, OnInit, Inject } from '@angular/core';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-alterar-lider-time-modal',
  templateUrl: './alterar-lider-time-modal.component.html',
  styleUrls: ['./alterar-lider-time-modal.component.scss']
})
export class AlterarLiderTimeModalComponent implements OnInit {
  liderSelecionado: any;
  funcionarios = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private funcionarioService: FuncionarioService,
    public dialogRef: MatDialogRef<AlterarLiderTimeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService
  ) { }

  ngOnInit() {
    this.liderSelecionado = this.data.LiderSelecionado;
    this.buscarFuncionarios();
  }

  salvar() {
    this.dialogRef.close(this.liderSelecionado);
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarFuncionarios() {
    this.carregandoService.mostra('buscaFuncionarios');

    this.funcionarioService.consultarTodosFuncionarios().subscribe(resp => {
      this.funcionarios = resp;
      if (this.funcionarios && this.funcionarios.length > 0) {
        if (!this.liderSelecionado) {
          this.liderSelecionado = this.funcionarios[0].idFuncion;
        }
      }
      this.carregandoService.esconde('buscaFuncionarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaFuncionarios');
      this.notificacaoService.erro(erro);
    });
  }
}
